// src/hooks/auth/recaptchaUtils.js
// Purpose: Concentrate reCAPTCHA DOM helpers so calling code stays focused on auth/MFA flow.

/**
 * Ensure the global base container exists outside React so it never unmounts
 * during route changes (prevents reCAPTCHA DOM from disappearing mid-flow).
 */
export function ensureGlobalRecaptchaContainer() {
  if (typeof document === 'undefined') return;
  if (!document.getElementById('recaptcha-container')) {
    const el = document.createElement('div');
    el.id = 'recaptcha-container';
    el.style.position = 'fixed';
    el.style.top = '0px';
    el.style.left = '0px';
    el.style.width = '1px';
    el.style.height = '1px';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    document.body.appendChild(el);
  }
}

/**
 * Create a unique child div under the global container for a single verifier instance.
 * This avoids the "already rendered in this element" error on repeated renders.
 */
export function createRecaptchaSlot(baseContainerId = 'recaptcha-container') {
  if (typeof document === 'undefined') return 'recaptcha-container';
  const base = document.getElementById(baseContainerId) || document.getElementById('recaptcha-container');
  if (!base) return 'recaptcha-container';
  try { base.normalize(); } catch (_) {}
  const uniqueId = `recaptcha-slot-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
  const child = document.createElement('div');
  child.id = uniqueId;
  child.style.width = '1px';
  child.style.height = '1px';
  child.style.opacity = '0';
  child.style.pointerEvents = 'none';
  base.appendChild(child);
  return uniqueId;
}

/**
 * Safely remove a previously created slot element by id (if used).
 * Use this after success or dialog close, not immediately after solve,
 * to avoid racing reCAPTCHA's internal cleanup steps.
 */
export function removeRecaptchaSlot(slotId) {
  if (typeof document === 'undefined' || !slotId) return;
  const el = document.getElementById(slotId);
  if (el && el.parentNode) {
    try { el.parentNode.removeChild(el); } catch (_) {}
  }
}


